module.exports = __webpack_public_path__ + "static/img/img1.f45d2426.png";